import React from "react";
import "./Poll.scss";

function Q1AnswerCopy({ pollQuestions }) {
  return (
    <p className="poll__question">
      {pollQuestions.aCopy1}
      <sup className="poll__question--sup">{pollQuestions.aSup1}</sup>
      {pollQuestions.aCopy2}
      <span className="poll__question--bold">{pollQuestions.answer}</span>
      <sup className="poll__question--sup">{pollQuestions.aSup2}</sup>
      {pollQuestions.aCopy3}
    </p>
  );
}

export default Q1AnswerCopy;
